import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * CountAnimation class
 */
export default class CountAnimation {
    constructor() {
        /**
         *
         * @type {{counters: string}}
         */
        this.defaults = {
            //elements
            counters: ".js-count",
        };
    }

    //region methods
    /**
     * CountAnimation class init method and init flag
     */
    init() {
        console.log("CountAnimation init()");

        this.counters = document.querySelectorAll(this.defaults.counters);

        if (this.counters.length > 0) {
            this.counterController();
        }
    }

    counterController() {
        for (let i = 0; i < this.counters.length; i++) {
            const delay = this.delayByItemsInRow(this.counters, this.counters[i]);
            const values = {
                count: 0,
            };

            gsap.to(values, {
                scrollTrigger: {
                    trigger: this.counters[i],
                    start: "top 70%",
                    toggleActions: "play none play none",
                },
                count: this.counters[i].dataset.value,
                ease: "power1.in",
                duration: 1.5,
                delay: delay + 0.2,
                onUpdate: () => {
                    if (parseFloat(this.counters[i].dataset.value) % 1 !== 0) {
                        this.counters[i].innerHTML = values.count.toFixed(1);
                    } else {
                        this.counters[i].innerHTML = Math.floor(values.count);
                    }
                },
            });
        }
    }

    /**
     *
     * @param items
     * @param current
     * @returns {number}
     */
    delayByItemsInRow(items, current) {
        const indexes = [];
        for (let i = 0; i < items.length; i++) {
            if (items[i].getBoundingClientRect().top === current.getBoundingClientRect().top) {
                indexes.push(i);
            }
        }

        const sum = indexes[indexes.length - 1] - indexes[0];

        if (sum === 0) {
            return 0;
        } else {
            for (let i = 0; i <= sum; i++) {
                if (items[indexes[i]] === current) {
                    return i * 0.15;
                }
            }
        }
    }

    //endregion
}
